module.exports = __webpack_public_path__ + "img/designguide1_pc.f447bc0b.png";